import Layout, { Footer, Header } from 'antd/lib/layout/layout';
import styles from './LayoutComponent.module.scss';
import * as React from 'react';
import CustomContext from '../../context/CustomContext';
import HeaderComponent from '../HeaderComponent/HeaderComponent';
import { PageType } from '../../model/types';
import { FormattedMessage } from 'react-intl';

class LayoutComponent extends React.Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    /*** COMPONENTS ***/

    render() {
        const { children, pageId, style } = this.props;

        return (
            <Layout className={styles.layout}>
                <Header>
                    <HeaderComponent pageId={pageId} />
                </Header>
                <div className={styles.content} style={style}>
                    {children}
                </div>
                <Footer className={styles.footer}>
                    <div className={styles.links}>
                        <a
                            href="https://docs.amazonpreconnector.com/docs/documentation/ZG9jOjc1MjgxMDQ-user-guide"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FormattedMessage id="footer.help" />
                        </a>
                    </div>
                    <a href="https://amazon.com">© Amazon</a>
                </Footer>
            </Layout>
        );
    }
}
export default LayoutComponent;

interface Props {
    pageId?: PageType;
    style?: React.CSSProperties;
}

interface State {}
